import {IBaseResponse, OxApi, Params as HttpParams} from '../interface';

export type HttpOptions = Record<string, unknown>;
export type Header = Record<string, string>;
export type UrlParams = string[];
export type ApiUrls = Record<string, OxApi<UrlType>>

export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE'
}

export type ApiMap = Map<string, OxApi<UrlType>>

/**
 * Ingests string parameters and interpolates them.
 * @returns a string.
 */
export type UrlMethod = (...args: any[]) => string;
/**
 * A token associated with an API's URL; makes for easier referencing.
 */
export type Token = keyof ApiUrls
/**
 * A URL represented by either a string literal or a method that produces a string.
 */
export type Url<T = string | UrlMethod> = T;
/**
 * Defines what types are allowed to be used in the URL<T> generic.
 */
export type UrlType = Token | UrlMethod

export type SetSession<A, T> = {
  session: A,
  response: IBaseResponse<T> | T,
  method: 'remove' | 'set',
  record?: OxApi<UrlType>,
  localized?: boolean
}


/**
 * ApiData Object
 * @property {string} tokenOrUrl Key value that is mapped to owner experience URL record or a simple string URL.
 * @property {boolean} [force]  Bypasses returning data stored in session, forces api call. Default is set to true.
 * @property {boolean} [localized] Set locale when storing in session
 * @property {HttpParams} [params] HTTP parameters
 * @property {Header[]} [headers] HTTP headers
 * @property {string[]} [urlParams] query params for the url
 * @property {Partial<any>} [data]  payload data
 */
export type ApiData = {
  tokenOrUrl: string | Token,
  urlParams?: string[],
  force?: boolean,
  localized?: boolean,
  params?: HttpParams,
  headers?: Header[],
  data?: unknown;
}
